import moment from 'moment';

import formatTime from "../helpers/formatTime";
import {formatUkTime, sessionInstant} from "../helpers/ukDate";

import {TIME_PICKER_STEP} from './lengthValidity';
import {timeFormat} from './timeFormatEn-GB';

/**
 * A taken session's start or end as the UK time of day ("HH:mm:ss") on ITS date - the API's times are UTC
 * times of day, and the UK offset depends on the date (BST or GMT), not on today.
 */
const ukTimeOfSession = (date, time) => `${formatUkTime(sessionInstant(date, time))}:00`;

const isTimeTaken = (time, takenSlots, isEndTime) => {
    let isAvailable = true;

    for (let slot of takenSlots) {
        const start = ukTimeOfSession(slot?.startDate, slot?.startsAt);
        const end = ukTimeOfSession(slot?.endDate, slot?.endsAt);

        const formattedTime = `${formatTime(time)}:00`;

        if (isAvailable) {
            isAvailable = isEndTime
                ? (formattedTime >= end || formattedTime <= start)
                : (formattedTime >= end || formattedTime < start);

        }

    }

    return isAvailable;
}

export default function getTimeOptionsArray(takenTimeSlots, isEndTime) {
    const timeOptions = [];
    new Array(24).fill().forEach((acc, index) => {
        const timeOption = moment({ hour: index }).format(timeFormat);

        const timeOptionWithMinutes = moment({ hour: index, minute: TIME_PICKER_STEP }).format(timeFormat);

        timeOptions.push({ label: `${timeOption}`, value: `${timeOption}` });
        timeOptions.push({ label: `${timeOptionWithMinutes}`, value: `${timeOptionWithMinutes}` });
    })

    return timeOptions.filter(option => isTimeTaken(option.value, takenTimeSlots, isEndTime));
}
